import React from "react";
import { HeaderName } from "../../../common/HeaderName";
import { IS_MOBILE } from "../../../common/Responsive";
import { priceSplit } from "../../../utils";

export const CancelPayment = ({
  items,
  confirm,
  back,
  mode,
  loading,
  redirect,
  fontSize = IS_MOBILE ? "f12-vw" : "f8-vw",
}) => {
  const detailPaymentMethod = (title, value) => {
    return (
      <div className={"d-flex flex-row mt-1 " + fontSize}>
        <div className="col px-0">
          <span className="grey">{title}</span>
        </div>
        <div className="col px-0">: {value}</div>
      </div>
    );
  };

  const detailPaymentCharge = (title, value, color = "text-black") => {
    return (
      <div className={"d-flex flex-row mt-1 " + fontSize}>
        <div className="col px-0">
          <span className="text-black">{title}</span>
        </div>
        <div className="col px-0">
          <div className="d-flex justify-content-between">
            <span className="text-black">Rp</span>
            <span className={color}>{priceSplit(value)}</span>
          </div>
        </div>
      </div>
    );
  };

  const detaiTotalPaid = (title, value, tax) => {
    return (
      <div className={"d-flex flex-row mt-1 " + fontSize}>
        <div className="col px-0">
          <span className="fw-700">{title}</span>
        </div>
        <div className="col px-0">
          <div className="d-flex justify-content-between">
            <div className="fw-700">Rp</div>
            <div className="">
              <div className="text-right fw-700">{priceSplit(value)}</div>
              {tax && (
                <div
                  className={IS_MOBILE ? "f8-vw grey" : "f6-vw grey"}
                  style={{
                    position: "relative",
                    right: 0,
                    top: 0,
                  }}
                >
                  Sudah termasuk pajak
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="d-flex flex-column p-3"
      style={{ width: IS_MOBILE ? "21rem" : "22rem" }}
    >
      <div className="text-center">
        <img
          src={
            mode === "cancel-payment"
              ? "/img/icon/cancel-payment.svg"
              : "/img/popup/cancel-success.svg"
          }
          alt=""
          style={{ width: 100 }}
          loading="lazy"
        />
      </div>
      <div className="col">
        <div className="d-flex flex-column">
          {mode === "cancel-payment" ? (
            <>
              <span
                className={
                  IS_MOBILE
                    ? "f14-vw font-weight-bold text-center"
                    : "f10-vw font-weight-bold text-center"
                }
              >
                Apakah anda yakin ingin
              </span>
              <span
                className={
                  IS_MOBILE
                    ? "f14-vw font-weight-bold text-center"
                    : "f10-vw font-weight-bold text-center"
                }
              >
                membatalkan pembayaran ini?
              </span>
            </>
          ) : (
            <span
              className={
                IS_MOBILE
                  ? "f14-vw font-weight-bold text-center"
                  : "f10-vw font-weight-bold text-center"
              }
            >
              Cancel Payment Success
            </span>
          )}
        </div>
        <hr className="separator-blue" />
      </div>
      <div className="col">
        <div className="d-flex flex-column">
          <div className="col px-0">
            <div className="">
              <HeaderName
                text="Informasi Pembayaran"
                fontSize={
                  IS_MOBILE
                    ? "f14-vw font-weight-bold"
                    : "f10-vw font-weight-bold"
                }
                color2="purple"
              />
            </div>
            {detailPaymentMethod("Metode Pembayaran", "Transfer Bank")}
            {detailPaymentMethod("Nama Bank", items?.to_bank_name)}
            {detailPaymentMethod("Nomor Rekening", items?.bank_accno)}
          </div>
          <div className="col px-0 mt-2">
            <div className="">
              <HeaderName
                text="Informasi Tagihan"
                fontSize={
                  IS_MOBILE
                    ? "f14-vw font-weight-bold"
                    : "f10-vw font-weight-bold"
                }
                color2="purple"
              />
              <div className="">
                {items?.process_type !== 12 ? (
                  <>
                    {detailPaymentCharge(
                      "Total Harga Kamar",
                      items?.room_charge
                    )}
                    {detailPaymentCharge(
                      "Early Check In",
                      items?.early_checkin
                    )}
                    <hr className="separator-blue my-2" />
                    {detaiTotalPaid("Total Tagihan", items?.total_charge, true)}
                    {detaiTotalPaid("Deposit (Cash)", items?.deposit, false)}
                  </>
                ) : (
                  <>
                    {detaiTotalPaid("Total Tagihan", items?.total_charge, true)}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="separator-blue mt-3 mb-2" />
      </div>
      {mode === "cancel-payment" && (
        <div className="text-center px-3">
          <span className={IS_MOBILE ? "f10-vw" : "f8-vw"}>
            Apakah anda yakin ingin melanjutkan?
          </span>
        </div>
      )}

      <div className="col mt-3">
        {mode === "cancel-payment" ? (
          <div className="d-flex justify-content-between">
            <div className="col-6 pl-0 pr-1" onClick={() => back()}>
              <button
                className={
                  "btn btn-sm btn-block btn-outline-purple " + fontSize
                }
              >
                Back
              </button>
            </div>
            <div
              className="col-6 pr-0 pl-1"
              onClick={() => {
                confirm(items.payment_id);
              }}
            >
              <button
                className={`btn btn-sm btn-block text-white ${fontSize} ${
                  loading ? "btn-secondary" : "btn-gradient"
                }`}
                disabled={loading ? true : false}
              >
                Confirm
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <div
              className="col-6 px-1"
              onClick={() => {
                redirect();
              }}
            >
              <button
                className={
                  "btn btn-sm btn-block bg-green rounded-input text-white " +
                  fontSize
                }
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
